import React from 'react';


const Spinner = (
  {
    absolute,
    marginLeft,
    marginRight,
    loading,
    top,
    left,
    color,
    fontSize,
    marginTop
  }
  ) => {
  return (
    <i
      className="fas fa-spinner fa-spin"
      style={{
        marginLeft: marginLeft || '0',
        marginRight: marginRight || '0',
        visibility: loading ? "visible" : "hidden",
        position: absolute ? "absolute" : "static",
        top: top || '0',
        left: left || '0',
        color: color || 'black',
        fontSize: fontSize || '16px',
        textAlign: 'center',
        marginTop: marginTop || '0'
      }}
    />
  )
};

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/spinner/spinner-component.js